import { httpCreate } from './http';

const http = httpCreate('/srv/invoice');

export const invoice = {
	infoCheck(id) {
		return http.get('/record/auth/' + id);
	},
	content() {
		return http.get('/content');
	},
	contentById(id) {
		return http.get('/content/' + id);
	},
	addInvoice(data) {
		return http.post('/content', data);
	},
	editInvoice(id, data) {
		return http.put('/content/' + id, data);
	},
	delInvoice(id) {
		return http.delete('/content/' + id);
	},
	getAddress() {
		return http.get('/site');
	},
	getAddressById(id) {
		return http.get('/site/' + id);
	},
	addAddress(data) {
		return http.post('/site', data);
	},
	editAddress(id, data) {
		return http.put('/site/' + id, data);
	},
	delAddress(id) {
		return http.delete('/site/' + id);
	},
	submitInvoice(data) {
		return http.post('/record', data);
	},
	getInvoiceList(data, params) {
		return http.post('/record/selectByParam', data, { params });
	},
	openInvoice(ids) {
		return http.post('/record/generate', ids);
	},
	updateInvoice(id, data) {
		return http.post('/record/updateExpress/' + id, data);
	},
	getInvoiceById(id) {
		return http.get('/record/' + id);
	}
};
